import { render, staticRenderFns } from "./ConfigurationIncidentOriginsGrid.vue?vue&type=template&id=4800ef6f&"
import script from "./ConfigurationIncidentOriginsGrid.vue?vue&type=script&lang=js&"
export * from "./ConfigurationIncidentOriginsGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports